export const ttpInfoSelector = ({ttpInfo}) => ttpInfo